/*
  Y2K PDP davranışları (CLAUDE.md §7) — Dawn JS'i YENİDEN YAZILMAZ (§14),
  üstüne eklenir. Tema editörü section:load'da yeniden kurulur.

  Madde 2: ana galeri görsellerine data-tilt (y2k-tilt.js bu dosyadan SONRA
  yüklenip tarar — main-product.liquid'deki script sırası önemli).
  Madde 4: - Dawn'ın stok dışı işaretlediği bedenler (input.disabled sınıfı)
             gerçek disabled attribute'una çevrilir: tıklanamaz + odaklanamaz.
             Dawn variant değişiminde picker'ı yeniden render ettiği için
             MutationObserver ile tekrar uygulanır.
           - Seçimsiz başlangıç: birden çok beden varsa sayfa seçili beden
             OLMADAN açılır (URL'de ?variant= yoksa). Tek bedenli üründe
             Dawn'ın ön seçimi korunur.
           - Beden seçilmeden SEPETE EKLE: gönderim durdurulur, seçiciye
             yumuşak scroll + kısa vurgu (panel sarsılmaz).
*/
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pillInputs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return scope.querySelectorAll('.product-form__input--pill input[type="radio"]');
  }

  /* ---------- Madde 2: galeri tilt ---------- */
  function setupGalleryTilt(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('media-gallery .product__media').forEach(function (m) {
      m.setAttribute('data-tilt', '');
    });
  }

  /* ---------- Madde 4a: stok dışı beden gerçekten kapalı ---------- */
  function markDisabled(root) {
    pillInputs(root).forEach(function (input) {
      if (input.classList.contains('disabled')) input.disabled = true;
    });
  }

  function watchPickerRerenders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs.dataset.y2kWatched) return;
      vs.dataset.y2kWatched = '1';
      new MutationObserver(function () {
        // Dawn picker'ı yeniden render etti: disabled + görsel kilit tazele
        markDisabled(vs);
        setupUnpicked();
      }).observe(vs, { childList: true, subtree: true });
    });
  }

  /* ---------- Madde 4b: seçimsiz başlangıç (GÖRSEL katman) ----------
     Radyoları gerçekten boşaltmak Dawn'ın state makinesiyle çatışıyor
     (Dawn hidrasyon/yeniden render'da seçimi geri getiriyor). Bunun yerine
     Dawn'ın ön seçimi DOKUNULMADAN korunur; fieldset'e y2k-unpicked sınıfı
     eklenir: seçili pill nötr görünür, kullanıcı bir bedene tıklayana kadar
     SEPETE EKLE engellenir. Dawn ile sıfır çatışma. */
  function setupUnpicked() {
    if (window.__y2kSizePicked) return;               // kullanıcı zaten seçti
    var inputs = pillInputs(document);
    if (inputs.length < 2) return;                    // tek beden: ön seçim kalsın
    if (/[?&]variant=/.test(location.search)) return; // linkle gelinen beden korunur
    document.querySelectorAll('.product-form__input--pill').forEach(function (fs) {
      fs.classList.add('y2k-unpicked');
    });
  }

  function clearUnpicked() {
    window.__y2kSizePicked = true;
    document.querySelectorAll('.product-form__input--pill.y2k-unpicked').forEach(function (fs) {
      fs.classList.remove('y2k-unpicked');
    });
  }

  // Kullanıcı beden seçti: görsel kilit kalkar (capture: Dawn'dan bağımsız)
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.product-form__input--pill input[type="radio"]')) return;
      clearUnpicked();
    },
    true
  );

  // KRİTİK: Dawn ilk bedeni teknik olarak checked tutar (kilit yalnızca
  // görsel). ZATEN seçili pill'e tıklamak/Space basmak change ÜRETMEZ —
  // kullanıcı "40"a tıklıyor ama kilit kalkmıyor, SEPETE EKLE sonsuza dek
  // engelleniyordu. Tıklama da seçim sayılır (label VEYA radyonun kendisi).
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('.product-form__input--pill label, .product-form__input--pill input[type="radio"]')
        : null;
      if (!t) return;
      var input = t.tagName === 'LABEL' ? t.control : t;
      if (!input || input.disabled) return;
      clearUnpicked();
    },
    true
  );

  // Chrome, ZATEN seçili radyoda Space için click olayı da üretmiyor —
  // klavye kullanıcısının "onayla" niyeti keyup'tan yakalanır
  document.addEventListener(
    'keyup',
    function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var t = e.target;
      if (!t || !t.matches || !t.matches('.product-form__input--pill input[type="radio"]')) return;
      if (t.disabled) return;
      clearUnpicked();
    },
    true
  );

  function sizeChosen() {
    return !document.querySelector('.product-form__input--pill.y2k-unpicked');
  }

  /* ---------- Madde 4c: EKLE'de yumuşak scroll + vurgu ---------- */
  // Dawn'ın submit handler'ından ÖNCE yakalamak için document capture.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      // DİKKAT: form.id KULLANILAMAZ — Shopify ürün formundaki
      // <input name="id"> form.id'yi gölgeleyip elementi döndürür.
      var formId = form && form.getAttribute ? form.getAttribute('id') : null;
      if (!formId || formId.indexOf('product-form-') !== 0) return;
      if (formId.indexOf('product-form-installment') === 0) return;
      if (form.closest && form.closest('quick-add-modal')) return;
      if (sizeChosen()) return;

      e.preventDefault();
      e.stopPropagation();

      var fieldset = document.querySelector('.product-form__input--pill');
      if (!fieldset) return;
      fieldset.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      fieldset.classList.remove('y2k-attention');
      void fieldset.offsetWidth; // animasyonu yeniden tetiklemek için reflow
      fieldset.classList.add('y2k-attention');

      // Görsel vurgu ekran okuyucuya ulaşmaz: odak ilk seçilebilir bedene
      // taşınır (klavyede de doğru yere iner) + canlı bölge duyurur
      var firstPick = fieldset.querySelector('input[type="radio"]:not(:disabled)');
      if (firstPick) firstPick.focus({ preventScroll: true });
      announce('Sepete eklemek için önce beden seçin.');
    },
    true
  );

  /* ---------- Ekran okuyucu duyuruları (görünmez canlı bölge) ---------- */
  function announce(msg) {
    var region = document.getElementById('Y2kA11yStatus');
    if (!region) {
      region = document.createElement('div');
      region.id = 'Y2kA11yStatus';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    // aynı metin art arda da okunsun diye önce boşaltıp sonra yaz
    setTimeout(function () { region.textContent = msg; }, 60);
  }

  /* ---------- Madde 5: SEPETE EKLE durum tasarımları (§7) ----------
     normal / hover: CSS'te. Burası loading + başarı:
     - Dawn loading sınıfını ekleyip spinner gösterir; CSS spinner'ı gizler,
       metin "EKLENİYOR…" + yanıp sönen ✦ olur.
     - Başarı sinyali Dawn'ın cartUpdate pub/sub yayını (yalnızca başarıda
       yayınlanır); buton 1.2 sn "SEPETTE ✦" gösterip normale döner,
       header'daki sepet pill'i zıplar. Hata durumunda metin anında eski
       hâline döner (Dawn hata mesajını kendisi gösterir). */
  var cartAddSignal = 0;

  function bounceCartPill() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    cart.classList.remove('y2k-bounce');
    void cart.offsetWidth; // animasyonu yeniden tetiklemek için reflow
    cart.classList.add('y2k-bounce');
    cart.addEventListener(
      'animationend',
      function () { cart.classList.remove('y2k-bounce'); },
      { once: true }
    );
  }

  // DİKKAT: PUB_SUB_EVENTS 'const' ile tanımlı — window'a YAZILMAZ;
  // bare identifier + typeof ile kontrol edilmeli (window.PUB_SUB_EVENTS undefined)
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate &&
    !window.__y2kCartSub
  ) {
    window.__y2kCartSub = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      cartAddSignal++;
      bounceCartPill();
    });
  }

  function setupButtonStates() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn || btn.dataset.y2kStates) return;
    btn.dataset.y2kStates = '1';
    var label = btn.querySelector('span');
    if (!label) return;

    var original = label.textContent;
    var signalAtStart = 0;
    var revertTimer = 0;

    new MutationObserver(function () {
      var loading = btn.classList.contains('loading');
      if (loading) {
        if (label.textContent !== 'EKLENİYOR…') original = label.textContent;
        signalAtStart = cartAddSignal;
        clearTimeout(revertTimer);
        label.textContent = 'EKLENİYOR…';
      } else if (label.textContent === 'EKLENİYOR…') {
        if (cartAddSignal > signalAtStart) {
          label.textContent = 'SEPETTE ✦';
          btn.classList.add('y2k-success');
          revertTimer = setTimeout(function () {
            btn.classList.remove('y2k-success');
            label.textContent = original;
          }, 1200);
        } else {
          label.textContent = original; // hata: anında normale dön
        }
      }
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Madde 6: mobil sticky bar görünürlüğü (§7) ----------
     Kurallar: ana SEPETE EKLE ekrandayken GİZLİ; buton scroll'la çıkınca
     belirir (IO); footer görünürken gizli (içeriği örtmez); klavye açıkken
     gizli (visualViewport). Bar butonu form= ile ana formu gönderdiğinden
     beden kilidi ve durum akışı otomatik geçerli; ana buton metni/disabled
     durumu bara aynen yansıtılır. */
  function setupStickyBar() {
    var bar = document.querySelector('[data-y2k-sticky]');
    if (!bar || bar.dataset.y2kInit) return;
    bar.dataset.y2kInit = '1';

    var mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn) return;
    // Footer'ın TAMAMI değil, son şeridi (copyright) esas alınır: kısa
    // PDP'de footer üst kenarı kuralı barın görünürlük bandını ~50px'e
    // düşürüyordu — bar yalnızca sayfanın gerçek sonunda çekilsin
    var footer = document.querySelector('.footer__content-bottom') || document.querySelector('.footer');

    var btnOut = false;
    var footerIn = false;
    var keyboard = false;

    function apply() {
      bar.classList.toggle('y2k-sticky-bar--visible', btnOut && !footerIn && !keyboard);
    }

    new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) btnOut = !entries[i].isIntersecting;
      apply();
    }, { threshold: 0 }).observe(mainBtn);

    if (footer) {
      // Footer'ın ilk pikseli değil, bar'ın gerçekten İÇERİĞİ örteceği an
      // esas alınır: kök alanın altından bar yüksekliği kadar kırpılır —
      // footer bu çizgiyi geçince bar gizlenir (sayfa sonunda örtme yok)
      var barH = Math.max(bar.offsetHeight, 72);
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) footerIn = entries[i].isIntersecting;
        apply();
      }, { threshold: 0, rootMargin: '0px 0px -' + barH + 'px 0px' }).observe(footer);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        // klavye açılınca görünür alan belirgin küçülür
        keyboard = window.visualViewport.height < window.innerHeight * 0.75;
        apply();
      });
    }

    // Ana buton metni + disabled + loading/success durumlarını bara yansıt
    var stickyBtn = bar.querySelector('[data-y2k-sticky-btn]');
    var stickyLabel = stickyBtn ? stickyBtn.querySelector('span') : null;
    var mainLabel = mainBtn.querySelector('span');
    if (stickyBtn && stickyLabel && mainLabel) {
      new MutationObserver(function () {
        stickyLabel.textContent = mainLabel.textContent;
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));
        stickyBtn.classList.toggle('y2k-success', mainBtn.classList.contains('y2k-success'));
      }).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    // Variant değişiminde ana fiyat bloğu yeniden render olur — bara yansıt
    var priceHost = document.querySelector('.product__info-container .price');
    var stickyPrice = bar.querySelector('[data-y2k-sticky-price]');
    if (priceHost && stickyPrice) {
      new MutationObserver(function () {
        var item = priceHost.querySelector('.price-item--sale, .price-item--regular, .price-item');
        if (item) stickyPrice.textContent = item.textContent.trim();
      }).observe(priceHost, { childList: true, subtree: true, characterData: true });
    }
  }

  function setup(root) {
    setupGalleryTilt(root);
    markDisabled(root);
    watchPickerRerenders(root);
    setupUnpicked();
    setupButtonStates();
    setupStickyBar();
  }

  setup(document);
  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target);
  });
})();
